import React, { useState } from "react";
import ReferenceAttachments from "./parts/ReferenceAttachments";
import UploadSection from "./parts/UploadSection";
import NotesField from "./parts/NotesField";

export default function BaseField({
  field,
  value,
  setValue,
  children,
  renderInlineChildren,
  openViewer,
  previewMode = false,
}) {
  const depth = field._branchDepth || 0;

  const [showUpload, setShowUpload] = useState(false);
  const [showNotes, setShowNotes] = useState(false);

  const baseClass = `mb-4 p-4 rounded-lg shadow-sm transition-all ${
    depth > 0
      ? `border-l-4 border-orange-500 bg-orange-50 dark:bg-orange-950/30 ${previewMode ? "pl-2.5 py-3 pr-3" : "pl-3"}`
      : `border-2 border-orange-500 bg-gray-50 dark:bg-gray-900 ${previewMode ? "p-3" : ""}`
  }`;

  return (
    <div
      className={`${baseClass} relative`}
      style={{
        marginLeft: depth ? depth * 8 : 0,
      }}
    >
      {/* top attachments */}
      <ReferenceAttachments field={field} openViewer={openViewer} />

      {/* main field content */}
      {children}

      {/* inline branching */}
      {renderInlineChildren?.()}

        {/* upload area - show compact buttons; media fields handle their own upload/notes UI.
          Hide upload/notes for location fields until those features are enabled. */}
        {field.type !== 'media' && field.type !== 'location' && (
        <div className="mt-3">
          <div className={previewMode ? "grid grid-cols-2 gap-2" : "flex flex-wrap items-center gap-3"}>
            <button
              type="button"
              onClick={() => setShowUpload((s) => !s)}
              className={`min-w-0 rounded text-center ${previewMode ? 'px-2 py-2 text-xs bg-gray-100 text-gray-500 cursor-not-allowed whitespace-normal leading-tight' : 'px-3 py-1 text-sm bg-orange-500 text-white'}`}
              disabled={previewMode}
            >
              {previewMode ? "Evidence" : "Upload Evidence"}
            </button>
            <button
              type="button"
              onClick={() => setShowNotes((s) => !s)}
              className={`min-w-0 rounded text-center ${previewMode ? 'px-2 py-2 text-xs bg-gray-100 text-gray-500 cursor-not-allowed whitespace-normal leading-tight' : 'px-3 py-1 text-sm bg-gray-100 text-gray-800'}`}
              disabled={previewMode}
            >
              {previewMode ? "Notes" : showNotes ? 'Hide notes' : 'Add notes'}
            </button>
          </div>

          {showUpload && !previewMode && (
            <div className="mt-2">
              <UploadSection field={field} value={value} setValue={setValue} openViewer={openViewer} />
            </div>
          )}

          {showNotes && !previewMode && (
            <div className="mt-2">
              <NotesField value={value} setValue={setValue} />
            </div>
          )}
        </div>
      )}
    </div>
  );
}

// local state hooks must be declared at component top-level; adding here to avoid refactor
